import React, { JSX, ReactNode } from 'react'
import './index.scss'
import Header from '@Components/ViewWork/Table/TableHeader'
import TableFooter from '@Components/ViewWork/Table/TableFooter'
import TableBody from '@Components/ViewWork/Table/TableBody'

export interface TableRowData {
    name?: string
    removeCellIdentifier?: string
    className?: string
    cells: ReactNode[]
    removable: boolean
    subTables?: TableInfo[]
}

export interface TableHeader {
    row: Array<{ text: string; tooltip?: JSX.Element }>
    removableCells?: boolean
}

export interface TableInfo {
    headerRow?: TableHeader
    rows: TableRowData[]
    footerRow?: ReactNode[]
    onRemoveCells?: (removedCellIndex: number, removeCellIdentifier?: string) => void
}

const Table = ({ headerRow, rows, footerRow, onRemoveCells }: TableInfo) => {
    const tableIsEmpty = rows.length === 0

    return (
        <>
            {!tableIsEmpty && (
                <div className="table">
                    {headerRow && <Header row={headerRow.row} removableCells={headerRow.removableCells} />}
                    <TableBody
                        rows={rows}
                        removableCells={headerRow?.removableCells}
                        onRemoveCellClicked={(index, removeCellIdentifier) => {
                            onRemoveCells && onRemoveCells(index, removeCellIdentifier)
                        }}
                    />
                    {footerRow && <TableFooter row={footerRow} />}
                </div>
            )}
        </>
    )
}

export default Table
